import { render } from "./svgicon.html?vue&type=template&id=5cad1675&scoped=true&external"
import script from "./svgicon.js?vue&type=script&lang=js&external"
export * from "./svgicon.js?vue&type=script&lang=js&external"

import "./svgicon.scss?vue&type=style&index=0&id=5cad1675&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cad1675"],['__file',"src/components/ui/svgicon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cad1675"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cad1675', __exports__)) {
    api.reload('5cad1675', __exports__)
  }
  
  module.hot.accept("./svgicon.html?vue&type=template&id=5cad1675&scoped=true&external", () => {
    api.rerender('5cad1675', render)
  })

}


export default __exports__